<template>
  <div>
    <b-container v-if="isLoading" class="text-center d-flex justify-content-center">
      <b-form>
        <br><br><br>
        <h5>{{ translate("loading") }}</h5>
        <br>
        <b-spinner style="color: rgb(109,122,82) !important"
          variant="warning"
        ></b-spinner>
      </b-form>
    </b-container>
    <div v-else>
      <b-container fluid v-if="this.inSession">
        <b-row>
          <b-col style="padding:0" align="center">
            <div class="menu-top" style="text-align:center">
              <p><b><span style="color: rgb(195,147,130)">WYNE</span></b>MAKER</p>
            </div>
            <div>
              <img class="menu-overlay"
                :src="require('@/assets/img/menu.png')"
                v-b-toggle.menu-sidebar
              >
            </div>
            <hr>
            <div class="m-box">
              <p style="text-align:right" class="w-subtitle">{{ translate("add wines") }}</p> 
              <b-row class="justify-content-center">
                <b-col 
                    class="w-tile m-2 d-inline-flex justify-content-center w-cursor-click"
                    xs="12" sm="6" md="4" lg="4" xl="3"
                    v-on:click="$router.push({path:'/Winery/WineEdit', query: {winery_id:$route.query.winery_id}})"
                    style ="display:block; min-width:300px; margin:20px !important"
                  >
                    <b-img
                      width=300px
                      height=200px
                      :src="require('@/assets/img/plus.png')"
                    >
                    </b-img>
                </b-col>
                
                <b-col
                  v-for="(wine, index) in wines"
                  v-bind:item="wine"
                  v-bind:index="index"
                  v-bind:key="wine._id" 
                  class="w-tile m-2 d-inline-flex justify-content-center"
                  xs="12" sm="6" md="4" lg="4" xl="3"
                  style ="display:block; min-width:300px; margin:20px !important"
                > 
                  <b-row 
                    style="width:95%"
                    v-on:click="$router.push({path:'/Winery/WineEdit', query: {winery_id:$route.query.winery_id,wine_id:wine._id }})"
                    >
                    <b-col cols="3" class="justify-content-center" style="height:100%;width:auto;padding:0">
                      <b-img center v-if="wine.image_files[0]"
                        style="height:100%;width:auto;position:absolute;right:0px"
                        v-bind:src="wine.image_files[0].dataURL" 
                      ></b-img>
                      <b-img center v-else
                        style="height:100%;width:auto;position:absolute;right:0px"
                        :src="require('@/assets/img/plus.png')"
                      ></b-img>
                    </b-col>
                    <b-col cols="9" class="d-table-cell">
                      <p class="t-title">{{wine.name}}</p>
                      <p class="t-subtitle" v-if="wine.type">{{wine.type}}</p>
                      <hr style="margin:5px 0 5px 0">
                      <p class="t-text" v-if="wine.appellation">{{wine.appellation}}</p>
                      <p class="t-text" v-if="wine.classification">{{wine.classification}}</p>
                      <p class="t-smalltext" v-if="wine.grapes">{{wine.grapes}}</p>
                    </b-col>
                  </b-row>
                  <div v-on:click="onDeleteWine(index)" class="delete-symbol">
                    <b-img
                      :src="require('@/assets/img/delete.png')"
                      style="width:100%;height:100%;border-radius:50%;border-style:none;position:relative;top: -35px;"
                    ></b-img>
                  </div>
                </b-col>
              </b-row>
            </div>
            <div class="m-box">
              <b-button v-on:click="onNext()" class="w-button-green-full">{{ translate("next") }}</b-button>
              <b-button v-on:click="onPrevious()" class="w-button-pink-full" style="margin-top:10px">{{ translate("previous") }}</b-button>
            </div>
          </b-col>
        </b-row>
        <b-sidebar 
          id="menu-sidebar" 
          backdrop
          backdrop-variant="dark" 
          no-header
          shadow
        >
          <template #default="{ hide }">
            <div style="display: flex; align-items: center;">
              <div style="display: flex;align-items: center; width:25 px">
                <b-dropdown 
                  left 
                  split 
                  text="language" 
                  class="language-dropdown" 
                  toggle-class="toggle-language" 
                  split-class="split-language" 
                  style="display: flex;font-size: 12px;margin:15px 0 0 10px"
                >
                  <template #button-content>
                    <img
                      :src="currentLanguageFlag"
                      style="width:28px; height:19px; border-radius:2px;"
                    >
                  </template>

                  <b-dropdown-item @click="selectLanguage('en')">
                    <img :src="require('@/assets/img/flags/english.png')" style="width: 37px; height: 25px;">
                    English
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('fr')">
                    <img :src="require('@/assets/img/flags/francais.png')" style="width: 37px; height: 25px;">
                    Français (French)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('de')">
                    <img :src="require('@/assets/img/flags/deutsch.png')" style="width: 37px; height: 25px;">
                    Deutsch (German)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('es')">
                    <img :src="require('@/assets/img/flags/spanish.png')" style="width: 37px; height: 25px;">
                    Español (Spanish)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('it')">
                    <img :src="require('@/assets/img/flags/italian.png')" style="width: 37px; height: 25px;">
                    Italiano (Italian)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('nl')">
                      <img :src="require('@/assets/img/flags/dutch.png')" style="width: 37px; height: 25px;">
                      Nederlands (Dutch)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('pt')">
                    <img :src="require('@/assets/img/flags/portuguese.png')" style="width: 37px; height: 25px;">
                    Português (Portuguese)
                  </b-dropdown-item>
                </b-dropdown>
              </div>
              <div style="display: flex; align-items: center;">
                <p style="margin:20px 0 0 40px;"><b><span style="color: rgb(195,147,130)">WYNE</span></b>MAKER</p>
              </div>
              <div style="display: flex; align-items: center; width:25 px">
                <img class="menu-overlay"
                  :src="require('@/assets/img/close.png')" 
                  style="width: 25px; height: 25px; cursor: pointer;" 
                  @click="hide"
                >
              </div>
            </div>
            <hr>
            <Menu/> 
          </template>  
        </b-sidebar>
      </b-container>
      <NoAccess v-else></NoAccess>
    </div>

    <b-modal id="deleteWine" ref="deleteWine" title="delete wine" @ok="deleteWine">
      <b-row v-if="current_index >=0">
        <b-col cols="3" class="justify-content-center" style="height:100%;width:auto;padding:0">
          <b-img center v-if="wines[current_index].image_files[0]"
            style="height:200px;width:auto;right:0px"
            v-bind:src="wines[current_index].image_files[0].dataURL" 
          ></b-img>
          <b-img center v-else
            :src="require('@/assets/img/bottle.png')"
            style="height:200px;width:auto;right:0px;"
          ></b-img>
        </b-col>
        <b-col cols="9" class="d-table-cell">
          <p class="t-title">{{wines[current_index].name}}</p>
          <p class="t-subtitle" v-if="wines[current_index].type">{{wines[current_index].type}}</p>
          <hr>
          <p class="t-text" v-if="wines[current_index].appellation">{{wines[current_index].appellation}}</p>
          <p class="t-text" v-if="wines[current_index].classification">{{wines[current_index].classification}}</p>
          <p class="t-smalltext" v-if="wines[current_index].grapes">{{wines[current_index].grapes}}</p>
        </b-col>
      </b-row>
      <p class="t-title text-center"> ARE YOU SHURE YOU WANT TO DELETE THIS WINE?</p>
      
      <template #modal-footer="{ ok, cancel }">
        <b-row style="width:100%">  
          <b-col class="text-left">
            <b-button class="w-button-pink" @click="cancel()">
              cancel
            </b-button>
          </b-col>
          <b-col class="text-right">
            <b-button class="w-button-green" @click="ok()">
              ok
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import {wordlist,translate_word} from '../assets/js/translate.js';
  
  import NoAccess from './NoAccess.vue'
  import Menu from './MenuMobile.vue'

  import Users from '../Users.js'

  import Wineries from '../Wineries.js'
  import Wines from '../Wines.js'

  export default {
    name: 'WineryWines',
    components: {
      NoAccess,
      Menu
    },
    computed : {
      inSession() {
        return this.$store.state.inSession
      },
      currentUser() {
        return this.$store.state.user
      },
      currentUserID() {
        return this.$store.state.user_id
      },      
      currentLanguage() {
        return this.$store.state.language
      },
      currentLanguageFlag() {
        const flags = {
          en: require('@/assets/img/flags/english.png'),
          fr: require('@/assets/img/flags/francais.png'),
          de: require('@/assets/img/flags/deutsch.png'),
          es: require('@/assets/img/flags/spanish.png'),
          it: require('@/assets/img/flags/italian.png'),
          nl: require('@/assets/img/flags/dutch.png'),
          pt: require('@/assets/img/flags/portuguese.png')
        }
        return flags[this.currentLanguage] || flags.en
      },             
    },
    data() {
      return {
        debug: false,

        isLoading: true,

        winery: {
          wine_ids: [],
          image_files: []
        },
        winery_id:0,

        wines:[],

        current_index: -1,

        isValid: true,
      }
    }, 
    async mounted() {
      if (this.debug) console.log('WineryWines in mounted: Fetching winery from DB '+ this.$route.query.winery_id);
      
      await Wineries.getone(this.$route.query.winery_id)
      .then(response=>{
        this.winery = response;
        this.winery_id = this.winery._id;
        delete this.winery._id;
        if (this.debug) console.log("WineryWines in mounted: Winery "+ this.winery.name + " succesfully fetched from DB");
      })
      .catch(error=>{
        if (this.debug) console.log("WineryWines in mounted: catch await Wineries.getone ERROR : ", error);
      })

      if (typeof this.winery.wine_ids === "undefined" || this.winery.wine_ids === null || this.winery.wine_ids === "") {
        this.winery.wine_ids = [];
      }
      for (var i=0; i < this.winery.wine_ids.length; i ++) {
        if (typeof this.winery.wine_ids[i] != "undefined" && this.winery.wine_ids[i] != null && this.winery.wine_ids[i] != "") {
           await Wines.getone(this.winery.wine_ids[i])
          .then(response=> {
            this.wines.push(response)
            if (this.debug) console.log('WineryWines in mounted: Wine with id= ', this.wines[i], ' succesfully fetched from DB')
          })
          .catch(error=>{
            if (this.debug) console.log('WineryWines in mounted: catch await Wines.getone ERROR : ' + error);
          })
        } else {
          if (this.debug) console.log('WineryWines in mounted: ERROR wine_ids[',i,'] = ', this.winery.wine_ids[i]);
        }
      }

      this.isLoading = false;
    },
    methods: { 
      async onSave() {
        if(this.isValid){
          await Wineries.update(this.$route.query.winery_id,this.winery)
          if (this.debug) console.log("WineryWines in onSave(): Submitted : ", this.winery)
        } 
      },
      async onNext() {
        await this.onSave()
        .then(response=>{
          if (this.debug) console.log("WineryWines in onNext():", response)
          this.$store.commit('setPage','Preview')
          this.$router.push({path:'/Winery/Preview', query: {winery_id:this.$route.query.winery_id }} );
        })
        
      },
      async onPrevious() {
        await this.onSave()
        .then(response=>{
          if (this.debug) console.log("WineryWines in onPrevious():", response)
          this.$store.commit('setPage','Pictures')
          this.$router.push({path:'/Winery/Pictures', query: {winery_id:this.$route.query.winery_id }} );
        }) 
      },
      onDeleteWine(i){
        this.current_index = i
        this.$bvModal.show('deleteWine')
      },

      async deleteWine(){
        let this_wine_id = this.winery.wine_ids[this.current_index]
        
        await Wines.delete(this_wine_id)
        .then(response => {
          console.log("WineryWines in deleteWine(): wine with id ", this_wine_id, " deleted with response : ", response)
        })
        .catch(error => {
          console.log('WineryWines in deleteWine() : catch await Wines.delete ERROR : ' + error);
        })

        this.winery.wine_ids.splice(this.current_index,1)
        await Wineries.update(this.winery_id,this.winery)
        .then(response => {
          console.log("WineryWines in deleteWine(): winery with id ", this.winery_id, " updated with response : ", response)
        })
        .catch(error => {
          console.log('WineryWines in deleteWine() : catch await Winery.update ERROR : ' + error);
        })

        this.wines.splice(this.current_index,1);
        this.current_index = -1;
      },

      async selectLanguage(language) {
        let local_debug = false
        if (local_debug || this.debug) console.log("TastingShow.selectLanguage: START");
        this.$store.commit('setLanguage',language)

        let user = this.currentUser
        let user_id = this.currentUserID
        user.language = language
        await Users.update(user_id, user)
        .then(response => {
          if (local_debug || this.debug) console.log ("TastingShow.selectLanguage: user ",user.email," updated with response ", response)
        })
        .catch(error => {
          if (local_debug || this.debug) console.log('TastingShow.selectLanguage: catch await Users.update ERROR : ', error);
        })

        this.refreshChild++

        if (local_debug || this.debug) console.log("TastingShow.selectLanguage: STOP");
      },

      translate(string) {
        // console.log("TMP string: ", string, " language: ", this.currentLanguage, " translation: ",translate_word(string, this.currentLanguage) )
        return translate_word(string, this.currentLanguage);
      },  
    }
  }
</script>
<style scoped>
.t-title {
  font-size: 18px;
  margin: 10px 0 0 0;
  text-align: left;
}

.t-subtitle {
  font-size:14px;
  margin:0.5vm;
  text-align: left;
}

.t-text {
  margin:0;
  font-size: 12px;
  text-align: left;
}

.t-smalltext {
  padding-top : 10px;
  font-size: 10px;
  text-align: left;
}
</style> 